/* Christmas World — cw-pillar.js
   Progressive enhancement for the pillar page template (page.pillar.json).
   v2 hub build — Michael-approved redesign (15 Sep 2026):
   1. Moves the lede + hero image + CTA buttons + stat grid from the body into
      the green hero panel (stats become the dark strip under the hero).
   2. Builds a sticky chip nav (.cw-chips-bar) from the page's H2s — smooth
      scroll, active-chip highlighting, auto-slugs missing ids. The old
      .cw-toc / .cw-pillar-toc blocks are hidden when chips are built.
   3. Converts the FAQ section (h3 + p pairs after the FAQ heading) into an
      accordion — and REMOVES the original h3s so questions don't render twice.
   4. Upgrades the plain guide links (.cw-blog-card divs or .cw-card anchors)
      into full blog cards (.cw-guide-card) with images, labels and dates.
   5. Relocates .cw-shopbar (if present) into a fixed bottom bar; hides it
      while the site footer is in view.
   6. Adds a back-to-top button.
   All content stays fully readable if this script fails to run — everything
   is progressive enhancement, no JS = plain render. */
(function () {
  "use strict";

  /* Article data for the guide cards (handle -> image, label, publish date).
     Pulled from the Shopify blog 15 Sep 2026 — refresh if articles change. */
  var GUIDE_DATA = {
    "how-to-set-up-christmas-lights-outdoor": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/daria-doroshenkova-pCJP8sjuqa8-unsplash.jpg?v=1663075834",
      label: "How-To & Installation",
      date: "14 September 2026"
    },
    "how-to-attach-christmas-lights-to-roof": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/roof.webp?v=1666880373",
      label: "How-To & Installation",
      date: "14 September 2026"
    },
    "led-christmas-lights-why-make-the-switch": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/white_lights.jpg?v=1566192289",
      label: "Comparison Guides",
      date: "14 September 2026"
    },
    "decorating-with-rope-lights": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/Red_Green_Colorful_Creative_Christmas_Decor_Pinterest_Pin_Facebook_Post_Landscape.png?v=1689746174",
      label: "Ideas & Inspiration",
      date: "14 September 2026"
    },
    "rope-lights-guide": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/cw-guide-rope-verandah.png?v=1788999201",
      label: "Care, Storage & Safety",
      date: "10 September 2026"
    },
    "electric-christmas-lights-guide": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/cw-guide-elec-hero.jpg?v=1788999175",
      label: "Care, Storage & Safety",
      date: "10 September 2026"
    },
    "battery-christmas-lights-guide": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/cw-guide-bat-jars.jpg?v=1788999225",
      label: "Care, Storage & Safety",
      date: "10 September 2026"
    },
    "usb-christmas-lights-guide": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/cw-guide-usb-hero.jpg?v=1788999148",
      label: "Care, Storage & Safety",
      date: "10 September 2026"
    },
    "solar-lights-care-guide": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/cw-guide-solar-hero.jpg?v=1788948934",
      label: "Care, Storage & Safety",
      date: "9 September 2026"
    },
    "choosing-the-right-size-christmas-tree": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/xmas4_71674d63-2abb-4979-b6f4-c91e5c3913cc.jpg?v=1789355642",
      label: "How-To & Installation",
      date: "14 September 2026"
    },
    "hinged-christmas-tree-guide": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/cw-guide-hinged-hero.jpg?v=1788997842",
      label: "Care, Storage & Safety",
      date: "10 September 2026"
    },
    "how-to-decorate-a-christmas-tree": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/cw-hero-ideas.jpg?v=1789103463",
      label: "How-To & Installation",
      date: "7 September 2026"
    },
    "fibre-optic-vs-led-christmas-tree": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/xmas3.jpg?v=1639961816",
      label: "Comparison Guides",
      date: "14 September 2026"
    },
    "best-christmas-display-ideas-for-indoors-and-outdoors": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/xmas4.jpg?v=1639962210",
      label: "Ideas & Inspiration",
      date: "14 September 2026"
    },
    "top-trending-christmas-decorations-for-2021": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/xmas_2.jpg?v=1639960514",
      label: "Ideas & Inspiration",
      date: "14 September 2026"
    },
    "top-3-front-porch-decor-ideas-for-this-holiday-season": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/xmas2.jpg?v=1639961310",
      label: "Ideas & Inspiration",
      date: "14 September 2026"
    },
    "top-christmas-tree-decoration-ideas": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/xmas5.jpg?v=1639962745",
      label: "Ideas & Inspiration",
      date: "14 September 2026"
    },
    "how-to-set-up-christmas-inflatables": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/How_To_Set_Up_Christmas_Inflatables.jpg?v=1681721596",
      label: "How-To & Installation",
      date: "14 September 2026"
    },
    "why-australians-celebrate-christmas-in-july": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/christmas_guy_summer.JPG?v=1563407337",
      label: "Christmas Planning",
      date: "14 September 2026"
    },
    "the-ultimate-christmas-cookies-recipe-a-delicious-australian-holiday-tradition": {
      img: "https://cdn.shopify.com/s/files/1/0957/8660/articles/Cookies_Blog.png?v=1725402086",
      label: "Christmas Planning",
      date: "14 September 2026"
    }
  };

  /* ---------- helpers ---------- */

  function headerHeight() {
    var v = getComputedStyle(document.documentElement)
      .getPropertyValue("--header-height");
    var n = parseInt(v, 10);
    return isNaN(n) ? 90 : n;
  }

  function slugify(text, used) {
    var s = String(text).toLowerCase().replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "").slice(0, 60);
    var base = s || "section";
    var n = 2;
    while (used[base]) { base = s + "-" + n; n++; }
    used[base] = true;
    return base;
  }

  /* Hero image: inside .cw-guide-hero (lights pillar) or a bare <img> at the
     top of the body (other pillars). Only looks before the quick answer/TOC. */
  function findHeroImg(body) {
    var children = body.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el.tagName === "IMG") return el;
      if (el.classList && el.classList.contains("cw-guide-hero")) {
        var im = el.querySelector("img");
        if (im) return im;
      }
      if (el.classList && (el.classList.contains("cw-quick-answer") ||
                           el.classList.contains("cw-toc"))) return null;
    }
    return null;
  }

  /* ---------- 1. hero: lede + image + CTAs + stats ---------- */

  function buildHero() {
    var heroInner = document.querySelector(".cw-pillar-hero__inner");
    var heroText = document.querySelector(".cw-pillar-hero__text");
    var body = document.querySelector(".cw-pillar-body");
    if (!heroInner || !heroText || !body) return;

    var lede = body.querySelector(".cw-pillar-lede");
    var img = findHeroImg(body);

    if (lede) {
      heroText.appendChild(lede); /* sits under the H1 in the green panel */
    }

    /* v2: CTA buttons (red solid + ghost) sit under the lede */
    var ctas = body.querySelector(".cw-pillar-ctas");
    if (ctas) heroText.appendChild(ctas);

    if (img) {
      /* capture the wrapper BEFORE the move, while the img is still inside it */
      var heroDiv = img.closest ? img.closest(".cw-guide-hero") : null;
      var wrap = document.createElement("div");
      wrap.className = "cw-pillar-hero__img";
      img.removeAttribute("width");
      img.removeAttribute("height");
      wrap.appendChild(img);
      heroInner.appendChild(wrap);
      if (heroDiv) heroDiv.style.display = "none"; /* empty shell once the img moves */
    }

    /* v2: stat grid becomes the dark strip along the hero's bottom edge */
    var stats = body.querySelector(".cw-pillar-stats");
    if (stats) {
      var hero = heroInner.closest(".cw-pillar-hero");
      if (hero) {
        var strip = document.createElement("div");
        strip.className = "cw-pillar-hero__stats";
        strip.appendChild(stats);
        hero.appendChild(strip); /* after the container = full-bleed strip */
      }
    }
  }

  /* ---------- 2. sticky chip nav ---------- */

  function buildChipNav() {
    var body = document.querySelector(".cw-pillar-body");
    var section = document.querySelector(".cw-pillar-section");
    var hero = document.querySelector(".cw-pillar-hero");
    if (!body || !section || !hero) return;

    var h2s = Array.prototype.slice.call(body.querySelectorAll("h2"));
    if (h2s.length < 2) return; /* a chip bar needs somewhere to jump */

    var used = {};
    var chips = [];
    h2s.forEach(function (h2) {
      if (h2.id) { used[h2.id] = true; }
      else { h2.id = slugify(h2.textContent || "", used); }
      var label = (h2.textContent || "").trim();
      if (label) chips.push({ el: h2, id: h2.id, label: label });
    });
    if (chips.length < 2) return;

    var bar = document.createElement("div");
    bar.className = "cw-chips-bar";
    var row = document.createElement("div");
    row.className = "cw-chips";

    var chipEls = [];
    chips.forEach(function (c, i) {
      var a = document.createElement("a");
      a.className = "cw-chip" + (i === 0 ? " cw-active" : "");
      a.href = "#" + c.id;
      a.textContent = c.label;
      row.appendChild(a);
      chipEls.push(a);
    });
    bar.appendChild(row);

    /* full-width bar between the hero and the content container */
    section.insertBefore(bar, hero.nextSibling);

    /* the chip bar replaces the in-body TOCs (kept for no-JS fallback) */
    var toc = body.querySelector(".cw-toc");
    if (toc) toc.style.display = "none";
    var ptoc = body.querySelector(".cw-pillar-toc");
    if (ptoc) ptoc.style.display = "none";

    var offset = function () { return headerHeight() + (bar.offsetHeight || 56) + 14; };

    row.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest(".cw-chip") : null;
      if (!a) return;
      var target = document.getElementById(a.getAttribute("href").slice(1));
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - offset();
      window.scrollTo({ top: top, behavior: "smooth" });
    });

    var setActive = function () {
      var line = offset() + 24;
      var idx = 0;
      for (var i = 0; i < chips.length; i++) {
        if (chips[i].el.getBoundingClientRect().top <= line) idx = i;
      }
      chipEls.forEach(function (el, i) {
        el.classList.toggle("cw-active", i === idx);
      });
      var active = chipEls[idx];
      if (active && row.scrollWidth > row.clientWidth) {
        row.scrollTo({ left: active.offsetLeft - 16, behavior: "smooth" });
      }
    };

    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { setActive(); ticking = false; });
    }, { passive: true });
    setActive();
  }

  /* ---------- 3. FAQ accordion ---------- */

  /* FAQ heading: h2#faqs (lights pillar) or any h2 whose id/text says FAQ. */
  function findFaqHeading(body) {
    var h2 = body.querySelector("h2#faqs");
    if (h2) return h2;
    var all = body.querySelectorAll("h2");
    for (var i = 0; i < all.length; i++) {
      var id = (all[i].id || "").toLowerCase();
      var txt = (all[i].textContent || "").toLowerCase();
      if (id.indexOf("faq") !== -1 || txt.indexOf("faq") !== -1 || txt.indexOf("frequently asked") !== -1) return all[i];
    }
    return null;
  }

  function buildFaqAccordion() {
    var body = document.querySelector(".cw-pillar-body");
    if (!body) return;
    var faqsH2 = findFaqHeading(body);
    if (!faqsH2) return;

    var node = faqsH2.nextElementSibling;
    var items = [];

    /* Geo bodies wrap the h3+p pairs in a div.cw-faq — descend into wrapper
       divs so the accordion still builds from the pairs inside. */
    if (node && node.tagName === "DIV" && node.querySelector("h3")) {
      node = node.firstElementChild;
    }

    /* Collect contiguous h3 + following <p> groups after the FAQs heading */
    while (node) {
      if (node.tagName !== "H3") break;
      var question = node;
      node = node.nextElementSibling;
      var answers = [];
      while (node && node.tagName === "P") {
        answers.push(node);
        node = node.nextElementSibling;
      }
      items.push({ question: question, answers: answers });
    }
    if (!items.length) return;

    var list = document.createElement("div");
    list.className = "cw-faq-list";

    /* Insert the accordion where the original questions sit, then remove them */
    items[0].question.parentNode.insertBefore(list, items[0].question);

    items.forEach(function (item, i) {
      var faq = document.createElement("div");
      faq.className = "cw-faq-item";

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cw-faq-q";
      btn.setAttribute("aria-expanded", i === 0 ? "true" : "false");

      var label = document.createElement("span");
      label.className = "cw-faq-q-text";
      label.innerHTML = item.question.innerHTML;
      btn.appendChild(label);

      var icon = document.createElement("span");
      icon.className = "cw-faq-icon";
      icon.setAttribute("aria-hidden", "true");
      btn.appendChild(icon);

      var answer = document.createElement("div");
      answer.className = "cw-faq-a";
      item.answers.forEach(function (p) { answer.appendChild(p); });
      if (i !== 0) answer.style.display = "none";

      btn.addEventListener("click", function () {
        var open = faq.classList.toggle("cw-faq-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        answer.style.display = open ? "" : "none";
      });

      faq.appendChild(btn);
      faq.appendChild(answer);
      list.appendChild(faq);

      /* Remove the original h3 so the question doesn't render twice */
      item.question.remove();
    });
  }

  /* ---------- 4. guide cards ---------- */

  /* Guide cards come in two shapes: .cw-blog-card divs (lights pillar) and
     .cw-card anchors (other pillars). Both get upgraded to .cw-guide-card. */
  function buildGuideCards() {
    var body = document.querySelector(".cw-pillar-body");
    if (!body) return;
    var container = body.querySelector(".cw-blog-cards");
    if (!container) return;

    /* NEW (17 Sep 2026): metafield-driven cards (custom.related_guides) take
       priority — server-rendered in cw-pillar.liquid, enriched with live
       article data. Swapped in here; the static links in page.content remain
       as the no-JS fallback. */
    var source = body.querySelector(".cw-kr-source");
    if (source && source.querySelector(".cw-guide-card")) {
      var container = body.querySelector(".cw-blog-cards");
      if (!container) {
        container = document.createElement("div");
        container.className = "cw-blog-cards";
        var h3 = document.createElement("h3");
        h3.textContent = "Keep reading";
        container.appendChild(h3);
        body.appendChild(container);
      }
      Array.prototype.forEach.call(container.querySelectorAll(".cw-blog-card, .cw-card"), function (el) {
        el.parentNode.removeChild(el);
      });
      Array.prototype.forEach.call(source.querySelectorAll(".cw-guide-card"), function (card) {
        container.appendChild(card);
      });
      source.parentNode.removeChild(source);
      return;
    }

    /* legacy fallback: GUIDE_DATA lookup table below (pages without the metafield) */
    var cards = Array.prototype.slice.call(container.querySelectorAll(".cw-blog-card, .cw-card"));
    cards.forEach(function (card) {
      var link = card.tagName === "A" ? card : card.querySelector("a[href*='/blogs/guides/']");
      if (!link) return;
      var m = link.getAttribute("href").match(/\/blogs\/guides\/([a-z0-9-]+)/);
      if (!m || !GUIDE_DATA[m[1]]) return;
      var data = GUIDE_DATA[m[1]];

      var title = (link.textContent || "").trim();
      var excerptEl = card.querySelector("p");
      var excerpt = excerptEl ? (excerptEl.textContent || "").trim() : "";

      var a = document.createElement("a");
      a.href = link.getAttribute("href");
      a.className = "cw-guide-card";

      var imgWrap = document.createElement("div");
      imgWrap.className = "cw-guide-card__img";
      var img = document.createElement("img");
      img.src = data.img + "&width=600&height=375&crop=center";
      img.alt = title;
      img.width = 600;
      img.height = 375;
      img.loading = "lazy";
      imgWrap.appendChild(img);

      var cardBody = document.createElement("div");
      cardBody.className = "cw-guide-card__body";
      if (data.label) {
        var tag = document.createElement("span");
        tag.className = "cw-guide-card__tag";
        tag.textContent = data.label;
        cardBody.appendChild(tag);
      }
      var h3 = document.createElement("h3");
      h3.className = "cw-guide-card__title";
      h3.textContent = title;
      cardBody.appendChild(h3);
      if (excerpt) {
        var p = document.createElement("p");
        p.className = "cw-guide-card__excerpt";
        p.textContent = excerpt;
        cardBody.appendChild(p);
      }
      if (data.date) {
        var date = document.createElement("span");
        date.className = "cw-guide-card__date";
        date.textContent = data.date;
        cardBody.appendChild(date);
      }

      a.appendChild(imgWrap);
      a.appendChild(cardBody);
      card.parentNode.replaceChild(a, card);
    });
  }

  /* ---------- 5. sticky shop bar ---------- */

  function buildShopbar() {
    var body = document.querySelector(".cw-pillar-body");
    if (!body) return;
    var shopbar = body.querySelector(".cw-shopbar");
    if (!shopbar) return;

    document.body.appendChild(shopbar); /* CSS makes it position: fixed */
    document.body.classList.add("cw-has-shopbar");

    var footer = document.querySelector("footer");
    if (footer && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var overFooter = entry.isIntersecting;
          shopbar.classList.toggle("cw-shopbar--hidden", overFooter);
          document.body.classList.toggle("cw-shopbar-clear", overFooter);
        });
      }, { threshold: 0.05 });
      io.observe(footer);
    }
  }

  /* ---------- 6. back to top ---------- */

  function buildBackToTop() {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cw-to-top";
    btn.setAttribute("aria-label", "Back to top");
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>';
    document.body.appendChild(btn);

    var onScroll = function () {
      btn.classList.toggle("cw-to-top--show", window.scrollY > 700);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }


  /* ---------- 7. product carousel (optional, metafield-driven) ----------
     The section template renders .cw-prod-slider after the body content;
     this moves it into position above the #shop section and wires arrows. */
  function buildProdSlider() {
    var slider = document.querySelector(".cw-prod-slider");
    if (!slider) return;
    var body = document.querySelector(".cw-pillar-body");
    var shopAnchor = body ? body.querySelector('h2[id="shop"]') : null;
    var afterAnchor = body ? body.querySelector('h2[id="collections"]') : null;
    if (afterAnchor && afterAnchor.parentNode !== slider.parentNode) {
      afterAnchor.parentNode.insertBefore(slider, afterAnchor);
    } else if (shopAnchor && shopAnchor.parentNode !== slider.parentNode) {
      /* fallback: no #collections heading — place right after #shop and its intro paragraph */
      var afterShop = shopAnchor.nextElementSibling;
      var insertPoint = (afterShop && afterShop.tagName === "P") ? afterShop.nextElementSibling : shopAnchor.nextElementSibling;
      shopAnchor.parentNode.insertBefore(slider, insertPoint);
    } else if (!shopAnchor && !afterAnchor && body && slider.parentNode !== body) {
      body.appendChild(slider);
    }
    /* Carousel itself is now the theme's native <hdt-slider> (card-product9) —
       it self-initialises via the theme's own custom element / slider JS,
       so no manual viewport/arrow wiring is needed here any more. */
  }

  /* ---------- init ---------- */


  /* ---------- 7. wrap H2 sections into alternating content bands ---------- */

  function wrapSections() {
    var body = document.querySelector(".cw-pillar-body");
    if (!body) return;
    var children = Array.prototype.slice.call(body.children);
    var firstH2 = children.findIndex(function (el) { return el.tagName === "H2"; });
    if (firstH2 === -1) return;

    var groups = [];
    var current = null;
    for (var i = firstH2; i < children.length; i++) {
      var el = children[i];
      if (el.tagName === "H2") {
        current = [el];
        groups.push(current);
      } else if (current) {
        current.push(el);
      }
    }

    groups.forEach(function (group, idx) {
      var band = document.createElement("div");
      band.className = "cw-pillar-sec-band" + (idx % 2 === 1 ? " cw-alt" : "");
      var anchor = group[0];
      anchor.parentNode.insertBefore(band, anchor);
      group.forEach(function (el) { band.appendChild(el); });
    });
  }

  /* ---------- 8. make section banner images clickable ---------- */

  var SECTION_LINKS = {
    "cw-pillar-types": { href: "/collections/christmas-lights", label: "Shop all Christmas lights" },
    "cw-pillar-choose": { href: "/collections/christmas-lights", label: "Shop the full range" },
    "cw-pillar-power": { href: "/blogs/guides/led-christmas-lights-why-make-the-switch", label: "Read the LED running-cost guide" },
    "cw-pillar-outdoor": { href: "/blogs/guides/how-to-set-up-christmas-lights-outdoor", label: "Read the outdoor setup guide" },
    "cw-pillar-display": { href: "/blogs/guides/decorating-with-rope-lights", label: "Read the rope light decorating guide" },
    "cw-pillar-care": { href: "/blogs/guides/solar-lights-care-guide", label: "Read the solar lights care guide" }
  };

  function linkSectionImages() {
    var figs = document.querySelectorAll(".cw-pillar-body .cw-section-img");
    figs.forEach(function (fig) {
      var img = fig.querySelector("img");
      if (!img) return;
      var src = img.getAttribute("src") || "";
      var key = Object.keys(SECTION_LINKS).filter(function (k) { return src.indexOf(k) !== -1; })[0];
      if (!key) return;
      var data = SECTION_LINKS[key];

      var a = document.createElement("a");
      a.href = data.href;
      a.className = "cw-section-img__link";
      a.setAttribute("aria-label", data.label);
      fig.parentNode.insertBefore(a, fig);
      a.appendChild(fig);

    });
  }


  /* ---------- 7. product carousel (optional, metafield-driven) ----------
     The section template renders .cw-prod-slider after the body content;
     this moves it into position above the #shop section and wires arrows. */
  function buildProdSlider() {
    var slider = document.querySelector(".cw-prod-slider");
    if (!slider) return;
    var body = document.querySelector(".cw-pillar-body");
    var shopAnchor = body ? body.querySelector('h2[id="shop"]') : null;
    var afterAnchor = body ? body.querySelector('h2[id="collections"]') : null;
    if (afterAnchor && afterAnchor.parentNode !== slider.parentNode) {
      afterAnchor.parentNode.insertBefore(slider, afterAnchor);
    } else if (shopAnchor && shopAnchor.parentNode !== slider.parentNode) {
      /* fallback: no #collections heading — place right after #shop and its intro paragraph */
      var afterShop = shopAnchor.nextElementSibling;
      var insertPoint = (afterShop && afterShop.tagName === "P") ? afterShop.nextElementSibling : shopAnchor.nextElementSibling;
      shopAnchor.parentNode.insertBefore(slider, insertPoint);
    } else if (!shopAnchor && !afterAnchor && body && slider.parentNode !== body) {
      body.appendChild(slider);
    }
    var viewport = slider.querySelector(".cw-prod-slider__viewport");
    var prev = slider.querySelector(".cw-prod-slider__arrow--prev");
    var next = slider.querySelector(".cw-prod-slider__arrow--next");
    if (!viewport) return;
    function cardStep() {
      var card = slider.querySelector(".cw-prod-card");
      return card ? card.getBoundingClientRect().width + 20 : 280;
    }
    if (prev) prev.addEventListener("click", function () { viewport.scrollBy({ left: -cardStep() * 2, behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { viewport.scrollBy({ left: cardStep() * 2, behavior: "smooth" }); });
  }

  /* ---------- init ---------- */

  buildHero();
  wrapSections();
  linkSectionImages();
  buildChipNav();
  buildGuideCards();
  buildFaqAccordion();
  buildProdSlider();
  buildShopbar();
  buildBackToTop();
})();
